function setBg() {
    $("[data-bg]").each(function (i,el) {
        let bgDesktop = $(el).attr("data-bg")
        let bgMob = $(el).attr("data-bg-mob")

        console.log(bgDesktop)
        console.log(bgMob)

        if(window.innerWidth>992){
            $(el).css(
                "background-image", `url(${bgDesktop})`
            )
        } else{
            $(el).css(
                "background-image", `url(${bgMob})`
            )
        }
    })
}

setBg()
window.addEventListener('resize', () => {
    setBg()
})
